import { Company } from "../Company";
import { CompanyRequest } from "../requests/CompanyRequest";
import FormElement, { formElement } from "./FormElement"

export type CompanyFormState = {
    name: FormElement<string>;
    isEnergyHarbourCustomer: FormElement<boolean>;
}

export function CompanyFormState_default(): CompanyFormState {
    return {
        name: formElement(""),
        isEnergyHarbourCustomer: formElement(false),
    }
} 

export function CompanyFormState_toRequest(formState: CompanyFormState): CompanyRequest {
    return {
        name: formState.name.value,
        isEnergyHarbourCustomer: formState.isEnergyHarbourCustomer.value
    }
}

export function CompanyFormState_fromCompany(company: Partial<Company>): CompanyFormState {
    return {
        name: formElement(company.name ?? ""),
        isEnergyHarbourCustomer: formElement(company.isEnergyHarbourCustomer ?? false)
    }
}